export default __webpack_public_path__ + "static/realnifty-3557ff682f2e90388fee5e0075c2b11a.png";